import consumer from "./consumer";

// La durée de vie de l'abonnement suit celle de la discussion Stimulus.
const subscribeToGroup = (container, callbacks) => consumer.subscriptions.create(
  { channel: "GroupChannel", id: container.dataset.groupId },
  callbacks
);

export { subscribeToGroup };
